<template>
  <div>
    <v-toolbar flat :color="ui.colorNavigationBar">
      <v-toolbar-title>
        <div :class="ui.responseHideXs">
          <a :class="ui.textTitle">
            {{info.title}}
          </a>
        </div>
        <div :class="ui.responseShowXs">
          <a :class="ui.textTitle">
            {{this.companyTitle2}}
          </a>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-for="btn in this.info.btns" :key="btn.id"
      :class="ui.responseHideXs">
        <v-btn v-if="btn.title === 'home'" :color="ui.textColor"
        @click="navButtonPressed()"
        small flat :to="preferredHomePage">
          <v-icon left color="wplblue1"> {{btn.icon}} </v-icon>
            {{btn.title}}
        </v-btn>
        <v-btn v-else small flat :to="btn.link" :color="ui.textColor"
        @click="navButtonPressed()">
          <v-icon left :color="ui.btnColor"> {{btn.icon}} </v-icon>
            {{btn.title}}
          </v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-for="btn in this.info.btns" :key="btn.id"
      :class="ui.responseShowXs">
        <v-btn small icon flat :to="btn.link" :color="ui.textColor"
        @click="navButtonPressed()">
          <v-icon :color="ui.btnColor"> {{btn.icon}} </v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import { mapGetters } from "vuex";
export default {
  mixins: [apptheme, publicGlobals],
  props: {
    info: Object
  },
  computed: {
    ...mapGetters(["getUser", "getEnableNavigationBarMove"]),
    preferredHomePage() {
      if (this.getUser.pref.page.home === "") {
        return "/welcomehome";
      } else {
        return this.getUser.pref.page.home;
      }
    }
  },
  methods: {
    navButtonPressed() {
      // do nothing
    }
  },
  data() {
    return {
      enableNavProgressBar: false
    };
  }
};
</script>
